var map = {
	"./1.jpg": 2239,
	"./10.jpg": 2240,
	"./2.jpg": 2241,
	"./3.jpg": 2242,
	"./4.jpg": 2243,
	"./5.jpg": 2244,
	"./6.jpg": 2245,
	"./7.jpg": 2246,
	"./8.jpg": 2247,
	"./9.jpg": 2248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2238;